import { render } from "./linkedin.svg?vue&type=template&id=782951e2"
const script = {}
script.render = render

export default script